var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.6665 9.91667C5.6665 9.54094 5.81576 9.18061 6.08144 8.91493C6.34711 8.64926 6.70745 8.5 7.08317 8.5H26.9165C27.2922 8.5 27.6526 8.64926 27.9182 8.91493C28.1839 9.18061 28.3332 9.54094 28.3332 9.91667C28.3332 10.2924 28.1839 10.6527 27.9182 10.9184C27.6526 11.1841 27.2922 11.3333 26.9165 11.3333H7.08317C6.70745 11.3333 6.34711 11.1841 6.08144 10.9184C5.81576 10.6527 5.6665 10.2924 5.6665 9.91667ZM5.6665 17C5.6665 16.6243 5.81576 16.2639 6.08144 15.9983C6.34711 15.7326 6.70745 15.5833 7.08317 15.5833H26.9165C27.2922 15.5833 27.6526 15.7326 27.9182 15.9983C28.1839 16.2639 28.3332 16.6243 28.3332 17C28.3332 17.3757 28.1839 17.7361 27.9182 18.0017C27.6526 18.2674 27.2922 18.4167 26.9165 18.4167H7.08317C6.70745 18.4167 6.34711 18.2674 6.08144 18.0017C5.81576 17.7361 5.6665 17.3757 5.6665 17ZM5.6665 24.0833C5.6665 23.7076 5.81576 23.3473 6.08144 23.0816C6.34711 22.8159 6.70745 22.6667 7.08317 22.6667H26.9165C27.2922 22.6667 27.6526 22.8159 27.9182 23.0816C28.1839 23.3473 28.3332 23.7076 28.3332 24.0833C28.3332 24.4591 28.1839 24.8194 27.9182 25.0851C27.6526 25.3507 27.2922 25.5 26.9165 25.5H7.08317C6.70745 25.5 6.34711 25.3507 6.08144 25.0851C5.81576 24.8194 5.6665 24.4591 5.6665 24.0833Z",
    fill: "#11B7B5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuMobile);
export default __webpack_public_path__ + "static/media/menu-mobile.5e4661d0.svg";
export { ForwardRef as ReactComponent };